<template>
    <v-layout row wrap>
        <v-layout v-for="(item, id) in content" :key="id" row
                  wrap class="card-extend"
        >
            <v-flex class="db-card wrapper-relative align-center d-flex"
                    :class="{'mr-0': $vuetify.breakpoint.xs, 'mr-4': $vuetify.breakpoint.smAndUp, 'mb-4': opened!=id, 'md3 xs6 card--active': opened==id}"
                    @click.self="open_card(item.database_id, id)"
            >
                {{ item.title }}
                <svg v-svg v-if="opened==id"
                     symbol="close"
                     size="16"
                     class="icon red-text card-extend__close"
                     role="presentation"
                     @click.self="close()"
                /> {{ opened }}
            </v-flex>
            <div v-if="opened==id && !item.database_id" class="card-extend__inner mb-4">
                <div class="pa-5">
                    <div class="flex mb-4">
                        <div class="headline mb-4">{{ item.text.title }}</div>
                        <div class="flex light-font">{{ item.text.text }}</div>
                    </div>
                    <div class="layout mt-4 row wrap">
                        <div v-for="(link, i) in item.links" :key="i">
                            <linkGreen class="mr-5" @click="modal_open_wrapper(link.database_id)">{{ link.title }}</linkGreen>
                        </div>
                    </div>
                </div>
            </div>
        </v-layout>
    </v-layout>
</template>

<script>
import linkGreen from '@/components/ui/links/styled/link_green.vue';
import {mapGetters, mapMutations, mapActions} from 'vuex';
export default {
  components: {
    linkGreen,
  },
  props: {
    // content: {
    //   type: Object,
    // },
  },
  data() {
    return {
      opened : null,
      content: [
        {
          title: 'Hyeta',
          text : {
            title: 'kokokokoko',
            text : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
          },
          links: [
            {
              database_id: 1,
              title      : 'BMW LL-01',
            },
            {
              database_id: 4,
              title      : 'BMW LL-04',
            },
            {
              database_id: 12,
              title      : 'BMW LL-12',
            },
            {
              database_id: 14,
              title      : 'BMW LL-14 FE+',
            },
          ],
        },
        {
          database_id: 1,
          title      : 'SA',
        },
        {
          database_id: 15,
          title      : 'SB',
        },
        {
          title: 'tryrt',
          text : {
            title: '76576756',
            text : 'Lorem ipsum dolor sit amet, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
          },
          links: [
            {
              database_id: 12,
              title      : 'BMW LL-12',
            },
            {
              database_id: 14,
              title      : 'BMW LL-14 FE+',
            },
          ],
        },
      ],

    };
  },
  computed: {
    ...mapGetters('database/modal', [
      'database_detail_modal',
      'current_detail',
    ]),
  },
  methods: {
    ...mapMutations('database/modal', [
      'CLOSE_MODAL',
      'OPEN_MODAL',
      'SET_CURRENT',
    ]),
    modal_open_wrapper(database_id) {
      this.OPEN_MODAL(this.database_detail_modal);
      this.SET_CURRENT(database_id);
    },
    close() {
      this.opened = null;
    },
    open_card(database_id, index) {
      if (database_id) {
        this.modal_open_wrapper(database_id);
      } else {
        this.opened = index;
      }
    },
  },
};
</script>

